import { render, staticRenderFns } from "./WorkBookNetWorthCalculator.vue?vue&type=template&id=64be17a6&scoped=true&"
import script from "./WorkBookNetWorthCalculator.vue?vue&type=script&lang=js&"
export * from "./WorkBookNetWorthCalculator.vue?vue&type=script&lang=js&"
import style0 from "./WorkBookNetWorthCalculator.vue?vue&type=style&index=0&id=64be17a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64be17a6",
  null
  
)

export default component.exports